/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../src/app/common/pager/pager.component';
var styles_Pager = [];
export var RenderType_Pager = i0.ɵcrt({ encapsulation: 2, styles: styles_Pager,
    data: {} });
function View_Pager_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 12, 'li', [['class',
                'page-item']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [['aria-label', 'Previous']], [[8, 'className',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.prevPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'span', [['aria-hidden', 'true']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-arrow-left']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [['class', 'sr-only']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Anterior'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('page-link ' + ((_co.curPage == 0) ? 'disabled' : ''));
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_Pager_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'li', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'a', [['class', 'page-link disabled']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToPage(_v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵted(null, ['\n                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getClassItem(_v.parent.context.index);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var currVal_1 = (_v.parent.context.index + 1);
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_Pager_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_Pager_4)),
        i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (((((_v.context.index == _co.curPage) || (_v.context.index == (_co.curPage - 1))) || (_v.context.index == (_co.curPage + 1))) || (_v.context.index == (_co.curPage - 2))) || (_v.context.index == (_co.curPage + 2)));
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_Pager_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 12, 'li', [['class',
                'page-item']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [['aria-label', 'Next']], [[8, 'className',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.nextPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'span', [['aria-hidden', 'true']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-arrow-right']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [['class', 'sr-only']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Siguiente'])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('page-link ' + ((_co.curPage == 1) ? 'disabled' : ''));
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_Pager_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class',
                'col-sm-12 bloquePaginado']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 13, 'nav', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 10, 'ul', [['class', 'pagination']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Pager_2)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_Pager_3)),
        i0.ɵdid(802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Pager_5)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.curPage > 0);
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = _co.pages;
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = (_co.curPage < _co.pcount);
        _ck(_v, 13, 0, currVal_2);
    }, null);
}
function View_Pager_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'col-sm-12 bloquePaginado']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'nav', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-circle-o-notch fa-spin fa-2x fa-fw ']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Cargando páginas ...\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, null);
}
export function View_Pager_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Pager_1)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Pager_6)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isLocked();
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.isLocked();
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
export function View_Pager_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'pager-view', [], null, null, null, View_Pager_0, RenderType_Pager)), i0.ɵdid(114688, null, 0, i2.Pager, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var PagerNgFactory = i0.ɵccf('pager-view', i2.Pager, View_Pager_Host_0, { pcount: 'pcount', psize: 'psize' }, { onNext: 'onNext', onPrev: 'onPrev',
    onGoto: 'onGoto' }, []);
//# sourceMappingURL=pager.component.ngfactory.js.map